"use strict";

exports.__esModule = true;
exports.CreateCommentActionDialog = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _core = require("@blueprintjs/core");
var _Logbook = require("../../Logbook");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var CreateCommentDialog = (0, _styledComponents["default"])(_core.Dialog).withConfig({
  displayName: "CreateCommentActionDialog__CreateCommentDialog",
  componentId: "sc-e1zy5s-0"
})([".", "{border-top:1px solid rgba(0,0,0,0.1);padding-top:1rem;}"], _core.Classes.DIALOG_FOOTER);

/**
 * Provides a function to a render prop which opens the operator panel
 * screen for the selected device.
 */
var CreateCommentActionDialog = exports.CreateCommentActionDialog = function CreateCommentActionDialog(props) {
  var logbook = (0, _react.useContext)(_Logbook.LogbookContext);
  var label = props.label,
    defaultCommentID = props.defaultCommentID;
  return /*#__PURE__*/_react["default"].createElement(CreateCommentDialog, {
    isOpen: props.isOpen,
    onClose: props.toggleDialog,
    title: label
  }, /*#__PURE__*/_react["default"].createElement("div", {
    "data-testid": "create-comment-dialog"
  }, /*#__PURE__*/_react["default"].createElement(_Logbook.NewLogbookCommentForm, {
    onClose: props.toggleDialog,
    device: logbook.device,
    defaultCommentID: defaultCommentID
  })));
};